import React, { Fragment, useState } from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import logo from "./logo.png";
import { dateFormat, getTime, dateFormatting } from "../utils/Utils";

const borderColor = "#90e5fc";
const blankRows = Array(6).fill(0);

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 200,
    height: 56,
    marginLeft: "auto",
    marginRight: "auto",
  },
  titleContainerName: {
    flexDirection: "row",
    marginTop: -8,
    justifyContent: "center",
    alignItems: "center",
  },
  reportTitleName: {
    color: "black",
    letterSpacing: 0,
    fontSize: 8,
    textAlign: "center",
  },
  invoiceNoContainer: {
    flexDirection: "row",
    marginTop: 36,
    justifyContent: "flex-end",
  },
  invoiceDateContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  invoiceDate: {
    fontSize: 12,
    fontStyle: "bold",
  },
  label: {
    width: 60,
  },
  labelWithRed: {
    width: 60,
    color: "red",
  },
  headerContainer: {
    marginTop: 70,
  },
  billTo: {
    marginTop: 20,
    paddingBottom: 3,
    fontFamily: "Helvetica-Oblique",
  },
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#bff0fd",
  },
  container: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    backgroundColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
    fontSize: 9, 
  },
  description: {
    width: "60%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  qty: {
    width: "8%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  itemName: {
    width: "30%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "left",
    paddingLeft: 8,
  },
  startDate: {
    width: "17%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  endDate: {
    width: "17%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  descriptionTotal: {
    width: "77%",
    textAlign: "right",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  amount: {
    width: "15%",
  },
  row: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontStyle: "bold",
    fontSize: 9,
  },
  description: {
    width: "60%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  qty: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  amount: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
  row: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "85%",
    textAlign: "right",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  total: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
  titleContainer: {
    flexDirection: "row",
    marginTop: 12,
  },
  reportTitle: {
    fontSize: 12,
    textAlign: "center",
    textTransform: "uppercase",
  },
  reportTitleTerms: {
    fontSize: 8,
    textAlign: "center",
  },
  termsAndConditions: {
    marginTop: 20,
    fontSize: 7,
    textAlign: "left",
  },
  bulletList: {
    marginTop: 10,
  },
  listItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  bullet: {
    marginRight: 5,
    fontSize: 10,
  },
  listItemText: {
    fontSize: 7,
  },
  rowA: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
    marginTop: 36,
  },
  columnA: {
    flex: 1, // Make each column take equal space
    marginRight: 10, // Add margin between columns
  },
  headerContainer: {
    position: "relative",
    width: "100%",
    alignItems: "center",
    marginBottom: 20,
  },

  qrAbsolute: {
    position: "absolute",
    right: 0,
    top: 0,
    width: 90,
    height: 90,
  },
});

const rows = blankRows.map((x, i) => (
  <View style={styles.row} key={`BR${i}`}>
    <Text style={styles.qty}> </Text>
    <Text style={styles.itemName}> </Text>
    <Text style={styles.startDate}> </Text>
    <Text style={styles.endDate}> </Text>
    <Text style={styles.rate}> </Text>
    <Text style={styles.qty}> </Text>
    <Text style={styles.qty}> </Text>
    <Text style={styles.amount}> </Text>
  </View>
));

// Create Document Component
const OrderPdf = ({
  products,
  customerName,
  customerNumber,
  address,
  invoiceId,
  orderDate,
  advance,
  amount,
  items,
  discount,
  orderitemdate,
  isDeliveredPrint,
  specialPrice,
  orderQr,
}) => {
  const productName = (proId) => {
    let data = products?.filter((data) => data._id === proId);

    return data?.[0]?.name;
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const formatDateComponent = (component) =>
      component.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = formatDateComponent(date.getMonth() + 1);
    const day = formatDateComponent(date.getDate());

    const hours = formatDateComponent(date.getHours());
    const minutes = formatDateComponent(date.getMinutes());
    const seconds = formatDateComponent(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const totalamount = items.map((item) => {
    const amount = item.amount;
    const days = item.days;
    const quantity = item.qnty;
    const totalamount = amount * days * quantity;
    return totalamount;
  });

  console.log(totalamount);

  const itemsRow = items?.map((item, index) => (
    <View style={styles.row} key={index}>
      <Text style={styles.qty}>{index + 1}</Text>

      <Text style={styles.itemName}>{productName(item.product)}</Text>

      <Text style={styles.startDate}>
        {item.startDate ? dateFormatting(item.startDate) : ""}
      </Text>

      <Text style={styles.endDate}>
        {item.endDate ? dateFormatting(item.endDate) : ""}
      </Text>

      <Text style={styles.rate}>{item.prodPrice}</Text>

      <Text style={styles.qty}>{item.qnty}</Text>

      <Text style={styles.qty}>{item.days}</Text>

      <Text style={styles.amount}>
        {item.prodPrice * item.days * item.qnty}
      </Text>
    </View>
  ));

  const [startdate, setStartDate] = useState("");

  console.log("PDF Items", JSON.stringify(items, null, 2));
  const sd = items.map((data) => console.log(data.startDate)); // This will also output: 2024-06-14T00:00:00.000Z

  console.log(orderDate);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerContainer}>
          {orderQr && <Image style={styles.qrAbsolute} src={orderQr} />}

          <Image style={styles.logo} src={logo} />

          <Text style={styles.reportTitleName}>
            Mini Road Changuvetty, Kottakkal, Malappuram - (+91)8078099472
          </Text>
        </View>

        <View style={styles.rowA}>
          <View style={styles.columnA}>
            <Text style={styles.columnText}>
              {" "}
              <View style={styles.invoiceNoContainer}>
                {/* <Text style={styles.billTo}>Bill To: {"\n"}</Text> */}

                <Text>
                  <Text style={styles.label}>Name : </Text>
                  {customerName} {"\n"}
                </Text>
                <Text>
                  <Text style={styles.label}>Place : </Text>
                  {address} {"\n"}
                </Text>
                <Text>
                  <Text style={styles.label}>Number : </Text>
                  {customerNumber} {"\n"}
                </Text>
              </View>
            </Text>
          </View>
          <View style={styles.columnA}>
            <Text style={styles.columnText}></Text>
          </View>
          <View style={styles.columnA}>
            <Text style={styles.columnText}>
              {" "}
              <Fragment>
                <View style={styles.invoiceNoContainer}>
                  <Text style={styles.label}>Invoice No:</Text>
                  <Text style={styles.invoiceDate}>
                    {`ADC_${invoiceId}`} {"\n"}
                  </Text>
                </View>
                <View style={styles.invoiceDateContainer}>
                  <Text style={styles.label}>Order Date: </Text>
                  <Text style={styles.boldText}>
                    {dateFormat(orderDate)} {"\n"}
                  </Text>
                </View>
                <View style={styles.invoiceDateContainer}>
                  <Text style={styles.label}>Status : </Text>
                  <Text>Order Placed</Text>
                </View>
              </Fragment>
            </Text>
            {isDeliveredPrint === true && (
              <Text style={styles.columnText}>
                {" "}
                <View style={styles.invoiceDateContainer}>
                  <Text style={styles.labelWithRed}>Delivered </Text>
                </View>
              </Text>
            )}
          </View>
        </View>

        <View style={styles.tableContainer}>
          <View style={styles.container}>
            <Text style={styles.qty}>No</Text>
            <Text style={styles.itemName}>Item</Text>
            <Text style={styles.startDate}>Start Date</Text>{" "}
            <Text style={styles.endDate}>End Date</Text>
            <Text style={styles.rate}>Price</Text>
            <Text style={styles.qty}>Qty</Text>
            <Text style={styles.qty}>Days</Text>
            <Text style={styles.amount}>Net Am</Text>
          </View>
          <Fragment>{itemsRow}</Fragment>
          <Fragment>{rows}</Fragment>
          <View style={styles.row}>
            <Text style={styles.description}>TOTAL</Text>
            <Text style={styles.total}> {amount}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.description}>Special Price</Text>
            <Text style={styles.total}> {specialPrice}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.description}>Advance</Text>
            <Text style={styles.total}> {advance}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.description}>Discount</Text>
            <Text style={styles.total}> {discount}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.description}>Balance</Text>
            <Text style={styles.total}>
              {" "}
              {amount - (parseInt(advance) + parseInt(discount))}
            </Text>
          </View>
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitle}>
            Thank you for your business
          </Text>{" "}
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitleTerms}> Terms & Conditions</Text>
        </View>
        <View style={styles.listItem}>
          <Text style={styles.bullet}>•</Text>
          <Text style={styles.listItemText}>
            {" "}
            It only issue or damage is loud in the returned product the client
            should give additional expenditure
          </Text>
        </View>
        <View style={styles.listItem}>
          <Text style={styles.bullet}>•</Text>
          <Text style={styles.listItemText}>
            {" "}
            * data lost by any technical issue we will not take the
            responsibility
          </Text>
        </View>
        <View style={styles.listItem}>
          <Text style={styles.bullet}>•</Text>
          <Text style={styles.listItemText}>
            {" "}
            * in case Returning time will extend the customer should inform the
            office staff other wise customer shoald pay an extra charge
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default OrderPdf;
